import {createElement} from "react";
import {createRoot} from "react-dom";

import {loadComponents} from "./functions/helpers";
import {GoogleMapBlock} from "./components/GoogleMap";
import {ArticlesList} from "./components/ArticlesList";
import {TopMenu} from "./components/TopMenu";

// log COMPILATION TIME
console.log('V:', COMPILE_TIME);


//Map of components available in front end and non-gutenberg admin parts
const uiComponents = {
    ArticlesList,
};

//Map of React components that are loaded within gutenberg block for preview and as such need to be re-loaded everytime the block is re-rendered.
const acfUIComponents = {
    'articles-list' : ArticlesList,
};


(function($){




    var loadBlocks = function() {
        // Masthead($);

        $(window).resize(function (){
        });

        loadComponents(uiComponents);
    }

    var eventHandlers = function() {

    }



    // Initialize each block on page load (front end).
    $(document).ready(function(){
        // console.log('jQuery Ready');
        loadBlocks();
        eventHandlers();
    });

    // Initialize dynamic block preview (editor) whenever acf block is reloaded in gutenberg.
    if( window.acf ) {
        //Attach React to hooks that are run after reloading acf gutenberg blocks so React components inside can also be re-loaded
        Object.entries(acfUIComponents).map(([key,item])=>{
            window.acf.addAction( 'render_block_preview/type='+key, () => {
                jQuery('[data-ui-component="'+item.name+'"]').each(function() {
                    const args = jQuery(this).data('args') || {}; //any extra arguments
                    args.component = item.name; //pass component name into args, some components (i.e. form based) might use it to identify themselves.
                    // render( createElement(item, {args:args}), jQuery(this)[0]);


                    const container = jQuery(this)[0];
                    const root = createRoot(container); // createRoot(container!) if you use TypeScript
                    root.render(createElement(item, {args:args}));
                })


            } );
        })
    }



})(jQuery);
